import { createEffect, createStore } from 'effector';
import { apartmentsApi, ApartmentInDB, ApartmentCreate } from '../api/apartments';

export const fetchApartmentsByCorpFx = createEffect(async (corpId: string) => {
  const list = await apartmentsApi.getByCorp(corpId);
  return { corpId, list };
});

export const createApartmentFx = createEffect(async (payload: ApartmentCreate) => {
  const created = await apartmentsApi.create(payload);
  return created;
});

export const $apartmentsByCorp = createStore<Record<string, ApartmentInDB[]>>({})
  .on(fetchApartmentsByCorpFx.doneData, (state, { corpId, list }) => ({ ...state, [String(corpId)]: list }))
  .on(createApartmentFx.doneData, (state, apt) => {
    const key = String(apt.corp_id);
    const prev = state[key] || [];
    return { ...state, [key]: [apt, ...prev] };
  });
